import Swiper, { Navigation, Pagination } from 'swiper'

const Numbers = () => {

  const swiper = new Swiper('.numbers-slider', {
    modules: [Navigation, Pagination],
    spaceBetween: 30,
    
    navigation: {
      nextEl: '.numbers-navigation .slider-button-next',
      prevEl: '.numbers-navigation .slider-button-prev',
    },
    
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },

    breakpoints: {
      0: {
        slidesPerView: 1.25,
      },
      580: {
        slidesPerView: 2.3,
      },
      768: {
        slidesPerView: 3.3,
      },
      1024: {
        slidesPerView: 3,
      },
      1234: {
        slidesPerView: 3,
      },
    },
  })
}

export default Numbers
